import {
  GET_STUDENT_ASSESSMENTS_ACCESSIBLE_LIST,
  GET_ACCESSIBLE_ASSESSMENTS_SUMMARY_BY_ACADEMIC_YEAR,
  RESET_ACCESSIBLE_ASSESSMENTS_DATA
} from './accessible-action-types'
import {
  SET_STUDENT_ASSESSMENTS_ACCESSIBLE_LIST,
  CHANGED_FILTER_ON_ACCESSIBLE_ASSESSMENTS,
  SET_ACCESSIBLE_ASSESSMENTS_LOADING,
  SET_MODULE_ASSESSMENTS_ACCESSIBLE_LIST,
  CHANGED_FILTER_ON_ACCESSIBLE_MODULE_ASSESSMENTS,
  RESET_ACCESSIBLE_ASSESSMENTS
} from './accessible-mutation-types'
import server from '../../server'
import moment from 'moment-es6'

const state = {
  currentFilter: 0,
  accessibleFilter: 0,
  modules: [],
  studentAssessments: [],
  studentAssessmentsFiltered: [],
  assessmentsLoading: false,
  yearFilters: [],
  studentModuleAssessments: [],
  studentModuleAssessmentsFiltered: [],
  yearModuleFilters: []
}

const mutations = {
  [SET_STUDENT_ASSESSMENTS_ACCESSIBLE_LIST] (state, list) {
    state.studentAssessments = []
    let years = []
    state.studentAssessments = list.map((item) => {
      years.push(item.submissionDate.substring(0, 4))
      let urls = []
      if (item.assessmentUrls.length > 0) {
        urls = item.assessmentUrls.map((url) => {
          return {
            label: url.label,
            url: url.url,
            type: url.urlType
          }
        })
      }
      if (item.assessmentUrl) {
        if (urls.length > 0) {
          urls.push({
            label: item.assessmentUrl,
            url: item.assessmentUrl,
            type: 'assessment'
          })
        } else {
          urls = [{
            label: item.assessmentUrl,
            url: item.assessmentUrl,
            type: 'assessment'
          }]
        }
      }
      return {
        module: item.module,
        description: item.description,
        assessmentUrl: urls,
        tutorFeedback: item.tutorFeedback,
        studentComment: item.studentComment,
        submissionDate: moment(item.submissionDate).format('ddd, DD/MM/YYYY'),
        assessmentGrade: item.grade,
        submissionYear: item.submissionDate.substring(0, 4)
      }
    })
    state.yearFilters = Array.from(new Set(years)).sort().reverse()
    state.studentAssessmentsFiltered = state.studentAssessments.filter(el => el.submissionYear === years[0])
  },
  [SET_MODULE_ASSESSMENTS_ACCESSIBLE_LIST] (state, list) {
    state.studentModuleAssessments = []
    let years = []
    list.map((item) => {
      years.push(item.academicYear)
      let totalAssessment = item.summary.map((summaryItem) => {
        let assessments = summaryItem.assessmentList.map((assessment) => {
          let urls = []
          if (assessment.assessmentUrls.length > 0) {
            urls = assessment.assessmentUrls.map((url) => {
              return {
                label: url.label,
                url: url.url,
                type: url.urlType
              }
            })
          }
          if (assessment.assessmentUrl) {
            if (urls.length > 0) {
              urls.push({
                label: assessment.assessmentUrl,
                url: assessment.assessmentUrl,
                type: 'assessment'
              })
            } else {
              urls = [{
                label: assessment.assessmentUrl,
                url: assessment.assessmentUrl,
                type: 'assessment'
              }]
            }
          }
          return {
            assessmentUrl: urls,
            tutorFeedback: assessment.tutorFeedback,
            studentComment: assessment.studentComment,
            submissionDueDate: assessment.submissionDueDate ? moment(assessment.submissionDueDate).format('ddd, DD/MM/YYYY') : undefined,
            submissionDate: assessment.submissionDate ? moment(assessment.submissionDate).format('ddd, DD/MM/YYYY') : 'N/A',
            assessmentType: assessment.assessmentType,
            assessmentGrade: assessment.submissionDate ? (assessment.grade ? assessment.grade : 'Awaiting') : 'N/A',
            assessmentIdentifier: assessment.resitFlag ? (assessment.assessmentIdDisplay ? assessment.assessmentIdDisplay : 'N/A') + '(Resit)' : assessment.assessmentIdDisplay
          }
        })
        return {
          moduleIdentifier: summaryItem.moduleCode,
          moduleDescription: summaryItem.moduleDescription,
          moduleGrade: summaryItem.moduleGrade,
          academicYear: item.academicYear,
          assessments: assessments
        }
      })
      totalAssessment.forEach(el => state.studentModuleAssessments.push(el))
    })
    state.yearModuleFilters = years
    state.studentModuleAssessmentsFiltered = state.studentModuleAssessments.filter(el => el.academicYear === years[0])
  },
  [CHANGED_FILTER_ON_ACCESSIBLE_ASSESSMENTS] (state, filter) {
    state.studentAssessmentsFiltered = state.studentAssessments.filter(el => el.submissionYear === filter)
  },
  [CHANGED_FILTER_ON_ACCESSIBLE_MODULE_ASSESSMENTS] (state, filter) {
    state.studentModuleAssessmentsFiltered = state.studentModuleAssessments.filter(el => el.academicYear === filter)
  },
  [SET_ACCESSIBLE_ASSESSMENTS_LOADING] (state, loading) {
    state.assessmentsLoading = loading
  },
  [RESET_ACCESSIBLE_ASSESSMENTS] (state) {
    state.currentFilter = 0
    state.accessibleFilter = 0
    state.modules = []
    state.studentAssessments = []
    state.studentAssessmentsFiltered = []
    state.assessmentsLoading = false
    state.yearFilters = []
    state.studentModuleAssessments = []
    state.studentModuleAssessmentsFiltered = []
    state.yearModuleFilters = []
  }
}

const actions = {
  [GET_STUDENT_ASSESSMENTS_ACCESSIBLE_LIST] ({commit, state}, studentId) {
    const actionData = {action: GET_STUDENT_ASSESSMENTS_ACCESSIBLE_LIST, data: studentId}
    commit(SET_ACCESSIBLE_ASSESSMENTS_LOADING, true)
    server.getReplayable(`/core/student/${studentId}/get/assessment`, actionData)
      .then(res => {
        commit(SET_STUDENT_ASSESSMENTS_ACCESSIBLE_LIST, res.data)
        commit(SET_ACCESSIBLE_ASSESSMENTS_LOADING, false)
      })
      .catch(error => {
        console.error(error)
        commit(SET_ACCESSIBLE_ASSESSMENTS_LOADING, false)
      })
  },
  [GET_ACCESSIBLE_ASSESSMENTS_SUMMARY_BY_ACADEMIC_YEAR] ({commit, state}, studentId) {
    const actionData = { action: GET_ACCESSIBLE_ASSESSMENTS_SUMMARY_BY_ACADEMIC_YEAR, data: studentId }
    commit(SET_ACCESSIBLE_ASSESSMENTS_LOADING, true)
    let data = {moduleId: null, academicYear: null}
    server.postReplayable(`/core/assessment/${studentId}/summaryByAcademicYear`, data, actionData)
      .then(res => {
        commit(SET_MODULE_ASSESSMENTS_ACCESSIBLE_LIST, res.data)
        commit(SET_ACCESSIBLE_ASSESSMENTS_LOADING, false)
      })
      .catch(error => {
        console.error(error)
        commit(SET_ACCESSIBLE_ASSESSMENTS_LOADING, false)
      })
  },
  [RESET_ACCESSIBLE_ASSESSMENTS_DATA] ({commit}) {
    commit(RESET_ACCESSIBLE_ASSESSMENTS)
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/accessibility/accessibleAssessments.js